import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ApiService } from "../../components/Common/ApiService";
import { isPending } from '../../store/actions/todoActions';

import { ReactComponent as LoginIcon } from "../../assets/icon/btn_login.svg";
import { ReactComponent as PasswordIcon } from "../../assets/icon/gg_lock.svg";
import { ReactComponent as UsernameIcon } from "../../assets/icon/gg_profile.svg";
import { ReactComponent as Logolight } from "../../assets/logo_light.svg";

import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import Button from "../../components/Common/Button";
import CheckBox from "../../components/Common/CheckBox";
import Input from "../../components/Common/Input";
import ModalBox from "../../components/Common/ModalBox";
import OTPInput from "../../components/Common/OTPInput";
import { formatTime, useHandleClickLoading } from "../../components/Common/utils";
import MobileAccessBanner from "../Hompages/MobileAccessBanner";

function LoginPages() {
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const [selectedButton, setSelectedButton] = useState("Masuk");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [konfirmasi_password, setKonfirmasi_password] = useState("");
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pin, setPIN] = useState("");
  const [keepLogin, setKeepLogin] = useState(false);
  const [isModalVerification, setIsModalVerification] = useState(false);

  const [remainingTime, setRemainingTime] = useState(180);
  const [intervalId, setIntervalId] = useState(null);

  const status = localStorage.getItem('isChoosePage');

  const dispatch = useDispatch();
  const location = useLocation();
  const handleClickLoading = useHandleClickLoading();

  useEffect(() => {
    setSelectedButton(status)
  }, [status]);

  useEffect(() => {
    if (remainingTime === 0) {
      clearInterval(intervalId);
    }
  }, [remainingTime]);
  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
    setUsername('')
    setPassword('')
    setFullname('')
    setPhone('')
    setEmail('')
  };


  const fetchLogin = async (phone, password, keepLogin) => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append("nomor", phone);
      params.append("password", password);
      params.append("keeplogin", keepLogin);

      const response = await ApiService({
        baseurl: "user/login",
        method: "POST",
        XGORDON: "LOGIN",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        if (
          response?.result.status_verifikasi === "Sudah Terverifikasi" &&
          response?.result.status_akun === "Aktif"
        ) {
          const apiKey = response?.result.api_key;
          const token = response?.result.token;
          const apiData = { apiKey, token };
          localStorage.setItem('isLogin', JSON.stringify(apiData));
          fetchDataProfile(apiKey, token)
        } else {
          handleSendOTP(phone, 'sendotp');
          const timer = setInterval(() => {
            setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
          }, 1000);
          setIntervalId(timer);
          return () => {
            clearInterval(timer);
          };
        }
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDataProfile = async (api_key, token) => {
    try {
      const params = new URLSearchParams();
      params.append("api_key", api_key);

      const response = await ApiService({
        baseurl: "user/me",
        method: "POST",
        XGORDON: "ME",
        apiKey: api_key,
        token: token,
        body: params,
      });
      if (response?.statusCode === 200) {
        localStorage.setItem('isProfile', JSON.stringify(response?.result));
        handleClickLoading("/");
      } else {

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchRegister = async (fullname, username, phone, email, password, konfirmasi_password) => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append("full_name", fullname);
      params.append("ponsel", phone);
      params.append("password", password);
      params.append("username", username);
      params.append("konfirmasi_password", konfirmasi_password);
      params.append("email", email);

      const response = await ApiService({
        baseurl: "user/register",
        method: "POST",
        XGORDON: "REGISTER",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        handleSendOTP(phone, 'sendotp');
        const timer = setInterval(() => {
          setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
        }, 1000);
        setIntervalId(timer);
        return () => {
          clearInterval(timer);
        };
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleLogin = (phone, password, keepLogin) => {
    const phoneRegex = /^\+62\d{8,17}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Nomor telepon tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    // Jika semua input valid, lanjutkan dengan proses login
    fetchLogin(phone, password, keepLogin);
  };
  const handleRegister = (fullname, username, phone, email, password) => {
    // Regex untuk fullname
    const fullnameRegex = /^[a-zA-Z\s-]+$/;
    if (!fullnameRegex.test(fullname)) {
      toast.error("Nama lengkap tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    // Regex untuk username
    const usernameRegex = /^[a-zA-Z0-9_-]{3,16}$/;
    if (!usernameRegex.test(username)) {
      toast.error("Username tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    // Regex untuk phone
    const phoneRegex = /^\+62\d{8,17}$/;
    if (!phoneRegex.test(phone)) {
      toast.error("Nomor telepon tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    // Regex untuk email
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(email)) {
      toast.error("Email tidak valid. Mohon periksa masukan Anda.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    // Jika semua input valid, lanjutkan dengan proses login
    fetchRegister(fullname, username, phone, email, password, konfirmasi_password);
  };
  const toggleModalVerification = () => {
    setIsModalVerification(!isModalVerification);
  };

  const handleSendOTP = async (phone, api) => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append('nomor', phone);

      const response = await ApiService({
        baseurl: "user/verifikasi",
        parameter: api,
        method: "POST",
        XGORDON: "VERIFIKASI",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        toggleModalVerification();
        toast.success(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleVerifAccount = async (phone, pin) => {
    dispatch(isPending(true));
    try {
      const params = new URLSearchParams();
      params.append('nomor', phone);
      params.append('otp', pin);

      const response = await ApiService({
        baseurl: "user/verifikasi",
        parameter: "verifotp",
        method: "POST",
        XGORDON: "VERIFIKASI",
        body: params,
      });
      dispatch(isPending(false));
      if (response?.statusCode === 200) {
        const apiKey = response?.result.api_key;
        const token = response?.result.token;
        const apiData = { apiKey, token };
        localStorage.setItem('isLogin', JSON.stringify(apiData));
        const timeoutId = setTimeout(() => {
          fetchDataProfile(apiKey, token)
        }, 500);
        return () => clearTimeout(timeoutId);
      } else {
        toast.error(response?.result.msg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  return (
    <div className="flex flex-col gap-3 flex-1 relatve">
      <div className="fixed top-0 left-0 bottom-0 right-0 bg-gradient-to-br from-[#FFB6FF] to-[#B9BDFF] " />
      <div className="flex flex-col gap-2 flex-1">
        <MobileAccessBanner />
        <div className="flex flex-row h-full  rounded-none gap-2 z-1">
          <div className="flex flex-col flex-1 bg-cardLight dark:bg-cardDark lg:rounded-xl shadow-inner">
            <div className="flex flex-col p-4 gap-2 items-center">
              <button onClick={() => handleClickLoading('/')}>
                <Logolight className=" h-14 w-52" />
              </button>
              <span
                className={`text-lg font-medium text-center`}
              >
                Selamat datang di <b className="text-[#22BDE2]">{parseWebSetting?.judul}</b>
              </span>
              <span
                className={`text-sm text-center line-clamp-2`}
              >
                {parseWebSetting?.deskripsi_footer}
              </span>
              <div className="flex flex-row w-full rounded-lg my-3 overflow-hidden  shadow-inner ">
                <Button
                  initialValue="Masuk"
                  color={`${selectedButton === "Masuk"
                    ? "#ffffff"
                    : "#22BDE2"
                    }`}
                  iconLeft={<LoginIcon className={`w-5 aspect-square `} />}
                  type="fill"
                  className={`h-14 px-4 ${selectedButton === "Masuk"
                    ? "bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                    : "bg-[#DFF9FF] text-[#22BDE2] hover:opacity-80"
                    } rounded-none justify-center items-center gap-2 inline-flex flex-1 transition-transform`}
                  onClick={() => handleButtonClick("Masuk")}
                />
                <Button
                  initialValue="Daftar"
                  type="fill"
                  color={`${selectedButton === "Daftar"
                    ? "#ffffff"
                    : "#22BDE2"
                    }`}
                  iconLeft={<LoginIcon className={`w-5 aspect-square `} />}
                  className={`h-14 px-4 ${selectedButton === "Daftar"
                    ? "bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                    : "bg-[#DFF9FF] text-[#22BDE2] hover:opacity-80"
                    } rounded-none justify-center items-center gap-2 inline-flex flex-1 transition-transform`}
                  onClick={() => handleButtonClick("Daftar")}
                />
              </div>

              {selectedButton === "Masuk" ? (
                <div className="flex flex-col gap-3 w-full">
                  <Input
                    label="Nomor Whatsapp"
                    id="phone"
                    icon={<UsernameIcon />}
                    value={phone}
                    type="tel"
                    placeholder={"Masukan Nomor Whatsapp"}
                    onChange={(event) => setPhone(event)}
                  />
                  <Input
                    label="Password"
                    id="password"
                    icon={<PasswordIcon />}
                    value={password}
                    type="password"
                    placeholder={"Masukan Password"}
                    onChange={(event) => setPassword(event)}
                  />
                  <CheckBox
                    label="Ingat Saya"
                    onChange={(event) => setKeepLogin(event)}
                  />
                  <Button
                    initialValue="Masuk"
                    type="fill"
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                    onClick={() => {
                      handleLogin(phone, password, keepLogin);
                    }}
                  />
                  <Button
                    initialValue="Lupa Password?"
                    type="fill"
                    className=" text-[#22BDE2]"
                    onClick={() => {
                      handleClickLoading("/forgotpassword")
                    }}
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-3 w-full">
                  <Input
                    label="Nama Lengkap"
                    id="fullname"
                    icon={<UsernameIcon />}
                    value={fullname}
                    type="text"
                    placeholder={"Masukan Nama Lengkap"}
                    onChange={(event) => setFullname(event)}
                  />
                  <Input
                    label="Username"
                    id="username"
                    icon={<UsernameIcon />}
                    value={username}
                    type="text"
                    placeholder={"Masukan Username"}
                    onChange={(event) => setUsername(event)}
                  />
                  <Input
                    label="Nomor Whatsapp"
                    id="phone"
                    icon={<UsernameIcon />}
                    value={phone}
                    type="tel"
                    placeholder={"Masukan Nomor Whatsapp"}
                    onChange={(event) => setPhone(event)}
                  />
                  <Input
                    label="Email"
                    id="email"
                    icon={<UsernameIcon />}
                    value={email}
                    type="email"
                    placeholder={"Masukan Email"}
                    onChange={(event) => setEmail(event)}
                  />
                  <Input
                    label="Password"
                    id="password"
                    icon={<PasswordIcon />}
                    value={password}
                    type="password"
                    placeholder={"Masukan Password"}
                    onChange={(event) => setPassword(event)}
                  />
                  <Input
                    label="Konfirmasi Password"
                    id="konfirmasi_password"
                    icon={<PasswordIcon />}
                    value={konfirmasi_password}
                    type="password"
                    placeholder={"Masukan Konfirmasi Password"}
                    onChange={(event) => setKonfirmasi_password(event)}
                  />
                  <Button
                    initialValue="Daftar"
                    type="fill"
                    className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor"
                    onClick={() => {
                      handleRegister(fullname, username, phone, email, password);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="hidden sm:flex md:hidden flex-col p-5 bg-[#22BDE2] rounded-tl-none rounded-bl-none" />
          <div className="hidden md:flex flex-col flex-1 bg-[#22BDE2] lg:rounded-xl rounded-tl-none rounded-bl-none">
            <img
              src={require('../../assets/images/pngwing 6.png')}
              alt="Logo"
              className="object-cover flex-1 h-full w-full " />
          </div>
        </div>
      </div>

      <ModalBox active={isModalVerification} onClose={toggleModalVerification}>
        <div className="flex flex-col gap-3 items-center">

          <img
            src={require("../../assets/images/dsawfg 2.png")}
            alt={"item.gambar"}
            className=" object-contain w-full h-full max-h-32 "
            effect="blur"
          />
          <span
            className={` text-base font-medium text-center`}
          >
            Verifikasi Akun Anda
          </span>
          <span
            className={` text-sm text-center`}
          >
            Masukan 6 Digit Kode Verifikasi yang dikirim ke Email Anda
          </span>
          <OTPInput
            onChange={(event) => setPIN(event)} />
          <div className="flex flex-row gap-2 justify-end w-full">
            {remainingTime === 0 ?
              <button onClick={() => {
                handleSendOTP(phone, 'resendotp');
              }} >
                <span className={` text-sm `}>Kirim ulang OTP</span>
              </button>
              :
              <span className={` text-sm `}>
                Kirim ulang kode unik dalam <b>{formatTime(remainingTime)}</b> detik
              </span>
            }
          </div>
          <Button
            initialValue="Verifikasi"
            type="fill"
            className="bg-gradient-to-r from-[#22BDE2] to-[#FC00FF]  text-darkColor w-full"
            onClick={() => {
              handleVerifAccount(phone, pin);
            }}
          />
        </div>
      </ModalBox>
    </div>
  );
}

export default LoginPages;
